
import Card from '../../../components/base/Card';

export default function ContactSection() {
  const contactMethods = [
    {
      icon: 'ri-phone-fill',
      title: 'Teléfono 1',
      info: '310 255 1833',
      description: 'Llámanos para pedidos urgentes',
      action: 'tel:+573102551833'
    },
    {
      icon: 'ri-phone-fill',
      title: 'Teléfono 2',
      info: '333 248 3675',
      description: 'Línea alternativa disponible',
      action: 'tel:+573332483675'
    },
    {
      icon: 'ri-phone-fill',
      title: 'Teléfono 3',
      info: '321 258 5307',
      description: 'Tercera línea disponible',
      action: 'tel:+573212585307'
    },
    {
      icon: 'ri-whatsapp-fill',
      title: 'WhatsApp 1',
      info: '310 255 1833',
      description: 'Chatea con nosotros',
      action: 'https://wa.me/573102551833'
    },
    {
      icon: 'ri-whatsapp-fill',
      title: 'WhatsApp 2',
      info: '333 248 3675',
      description: 'Línea alternativa WhatsApp',
      action: 'https://wa.me/573332483675'
    },
    {
      icon: 'ri-whatsapp-fill',
      title: 'WhatsApp 3',
      info: '321 258 5307',
      description: 'Tercera línea WhatsApp',
      action: 'https://wa.me/573212585307'
    }
  ];

  const handleContactClick = (action: string) => {
    if (action === 'chat') {
      document.querySelector('#vapi-widget-floating-button')?.click();
    } else {
      window.open(action, '_blank');
    }
  };

  return (
    <section id="contacto" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Contáctanos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estamos aquí para ayudarte. Contáctanos por el medio que prefieras y 
            te atenderemos de inmediato. Entrega en 30-45 minutos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {contactMethods.map((method, index) => (
            <Card 
              key={index} 
              hover 
              className="p-6 text-center cursor-pointer"
              onClick={() => handleContactClick(method.action)}
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-red-100 rounded-full">
                <i className={`${method.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">{method.title}</h3>
              <p className="text-red-600 font-semibold mb-2">{method.info}</p>
              <p className="text-sm text-gray-600">{method.description}</p>
            </Card>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Horarios de Atención</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="font-medium text-gray-700">Lunes a Domingo</span>
                <span className="text-red-600 font-semibold">24 Horas</span>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="font-medium text-gray-700">Días Festivos</span>
                <span className="text-red-600 font-semibold">24 Horas</span>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="font-medium text-gray-700">Tiempo de Entrega</span>
                <span className="text-red-600 font-semibold">30-45 min</span>
              </div>
            </div>

            <div className="mt-8">
              <h4 className="text-lg font-semibold text-gray-800 mb-4">Información Adicional</h4>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-fill text-green-600"></i>
                  </div>
                  <span>Entrega rápida en 30-45 minutos</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-fill text-green-600"></i>
                  </div>
                  <span>Pago contraentrega disponible</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-fill text-green-600"></i>
                  </div>
                  <span>Productos 100% originales garantizados</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-check-fill text-green-600"></i>
                  </div>
                  <span>Cobertura en todas las localidades de Bogotá</span>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Zona de Cobertura</h3>
            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <h4 className="font-semibold text-gray-800 mb-4">Localidades Atendidas:</h4>
              <div className="grid grid-cols-2 gap-2 text-sm text-gray-600">
                <div>• Usaquén</div>
                <div>• Chapinero</div>
                <div>• Santa Fe</div>
                <div>• San Cristóbal</div>
                <div>• Usme</div>
                <div>• Tunjuelito</div>
                <div>• Bosa</div>
                <div>• Kennedy</div>
                <div>• Fontibón</div>
                <div>• Engativá</div>
                <div>• Suba</div>
                <div>• Barrios Unidos</div>
                <div>• Teusaquillo</div>
                <div>• Los Mártires</div>
                <div>• Antonio Nariño</div>
                <div>• Puente Aranda</div>
                <div>• La Candelaria</div>
                <div>• Rafael Uribe</div>
                <div>• Ciudad Bolívar</div>
                <div>• Y más...</div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-6 text-white text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-whatsapp-fill text-3xl"></i>
                </div>
                <h4 className="text-lg font-bold mb-2">WhatsApp 1</h4>
                <p className="mb-4 text-green-100">310 255 1833</p>
                <button 
                  onClick={() => window.open('https://wa.me/573102551833', '_blank')}
                  className="bg-white text-green-600 hover:bg-gray-100 font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  Chatear
                </button>
              </div>

              <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg p-6 text-white text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-whatsapp-fill text-3xl"></i>
                </div>
                <h4 className="text-lg font-bold mb-2">WhatsApp 2</h4>
                <p className="mb-4 text-blue-100">333 248 3675</p>
                <button 
                  onClick={() => window.open('https://wa.me/573332483675', '_blank')}
                  className="bg-white text-blue-600 hover:bg-gray-100 font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  Chatear
                </button>
              </div>

              <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg p-6 text-white text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-whatsapp-fill text-3xl"></i>
                </div>
                <h4 className="text-lg font-bold mb-2">WhatsApp 3</h4>
                <p className="mb-4 text-purple-100">321 258 5307</p>
                <button 
                  onClick={() => window.open('https://wa.me/573212585307', '_blank')}
                  className="bg-white text-purple-600 hover:bg-gray-100 font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  Chatear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
